@import 'styles/mixins';
@import 'styles/blaze/mixins';

.instagramPostLoadingPreview {
  border-radius: 20px;
  border: 1px solid var(--dark-8);
  background: var(--light-100);
  box-shadow: 0px 20px 80px 0px var(--dark-10);
  display: flex;
  flex-direction: column;
  width: 27%;
  min-width: 360px;
  min-height: 80%;

  .header {
    margin-bottom: 20px;
    padding: 14px 18px 0 18px;

    :global .ant-skeleton {
      .ant-skeleton-paragraph {
        display: flex;
        flex-direction: column;
        gap: 4px;
        padding: 7px 0;

        li {
          border-radius: 90px;
          margin-top: 0 !important;
          height: 18px;
          width: 150px;
        }
      }
    }
  }

  .body {
    @include blur(5px);
    height: 100%;
    opacity: 0.4;
    background: linear-gradient(180deg, var(--light-100) 0%, var(--brand-kit-color) 100%);
  }

  .footer {
    display: flex;
    align-items: center;
    justify-content: space-around;
    padding: 12px;
    width: 100%;

    :global .ant-skeleton {
      .ant-skeleton-paragraph {
        display: flex;
        flex-direction: column;
        gap: 12px;

        li {
          border-radius: 90px;
          margin-top: 0 !important;
          height: 10px;
        }

        li:last-child {
          width: 259px !important;
          height: 10px;
        }
      }
    }
  }
}
